import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import { useState } from "react";

export function PasswordField(props:TextFieldProps){
  const [visible,setVisible]=useState(false);
  return <TextField {...props} type={visible?"text":"password"} slotProps={{...props.slotProps,input:{...props.slotProps?.input,endAdornment:<InputAdornment position="end"><IconButton edge="end" aria-label={visible?"Hide password":"Show password"} onClick={()=>setVisible(v=>!v)}>{visible?<VisibilityOffOutlined/>:<VisibilityOutlined/>}</IconButton></InputAdornment>}}}/>;
}
